module.exports = __webpack_public_path__ + "img/teamImg8.3ef51989.jpg";